import { Outlet } from "react-router-dom";

export default function ServicesIndex() {
  return <Outlet />;
}
